import QrCodeIcon from '@mui/icons-material/QrCode';
import Fab from '@mui/material/Fab';

export interface QrFabProps {
  title: string;
  onClick: () => void;
}

export const QrFab = (props: QrFabProps) => {
  return (
    <Fab variant="extended" onClick={props.onClick} color="primary">
      <QrCodeIcon sx={{ mr: 1 }} />
      {props.title}
    </Fab>
  );
};
